import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { DEVELOPMENT_TYPE } from "Constants";
import ScheduleItem from "./schedule_item";
import FakeScheduleItem from "./fake_schedule_item";
import { TRACK_COLORS, HEIGHT_PER_HOUR } from "ScheduleConstants";
const trackW = 200;
const trackH = 200;
class ScheduleTrack extends Component {
  constructor(props) {
    super(props);
  }

  renderSessions = () => {
    if (!this.props.sessions) return "";
    var items = this.props.sessions.map((session) => {
      var color = _.shuffle(TRACK_COLORS)[0];
      // var sessionAssocUsers = _.filter(this.props.sessionUsers, (obj) => {
      //   return obj.sessionid == session.sessionid;
      // }); // Selecting session associated users.
      // console.log("sessionAssocUsers := ", sessionAssocUsers);

      return (
        <ScheduleItem
          key={session.session.sessionid}
          schedule={{
            ...session.session,
            color: color,
            // sessionAssocUsers: sessionAssocUsers,
          }}
          layout={session.layout}
        />
      );
    });
    // if(items.length>0)
    return [
      items,
      <FakeScheduleItem
        key={-1}
        schedule={this.props.lastSession}
        track={this.props.track}
        scheduleSession={this.props.sessions}
      />,
    ];

    // return items;
  };

  render() {
    let { sessionScreenZoom, timeSlots, mawWidth } = this.props;
    let heighPerHour = !_.isEmpty(sessionScreenZoom)
      ? sessionScreenZoom.height
      : HEIGHT_PER_HOUR;
    let height =
      timeSlots.length > 0 ? heighPerHour * timeSlots.length : trackH;
    let customWidth = mawWidth > 0 ? mawWidth : trackW;

    return (
      <td
        className="track-container"
        style={{ width: customWidth, height: height }}
      >
        <div className="track-info" style={{ width: customWidth }}>
          {this.renderSessions()}
        </div>
      </td>
    );
  }
}

function getPositionOfSessions(data, startTime, sessionScreenZoom) {
  let left, top, height, width;
  let maxWidth = 0;
  const arrPositions = [];

  var heightPerHour = !_.isEmpty(sessionScreenZoom)
    ? sessionScreenZoom.height
    : HEIGHT_PER_HOUR; // Height per pixel calculated on hour
  var heightPerSecond = heightPerHour / 60 / 60; // Height per second

  // Calculates basic expected layout for a session.
  function getExpectedLayout(stime, endtime) {
    return {
      left: 0,
      top: (stime - startTime) * heightPerSecond,
      width: 180,
      height: (endtime - stime) * heightPerSecond,
    };
  }

  /**
   * Checks proper layout x and y based on overlaps.
   */
  function findLayoutPosition(layout, index) {
    for (let i = 0; i < index; i++) {
      const cLayout = arrPositions[i].layout;
      if (cLayout.top + cLayout.height > layout.top) {
        if (layout.left === cLayout.left) {
          layout.left = cLayout.left + layout.width + 15;

          if (layout.left >= maxWidth) {
            maxWidth = layout.left;
          }
        }
        findLayoutPosition(layout, i);
      }
    }
  }

  // Creating layout positions for every sessions in the data array.
  data.forEach((session) => {
    const layout = getExpectedLayout(
      moment(session.starttime).unix(),
      moment(session.endtime).unix()
    );
    findLayoutPosition(layout, arrPositions.length);
    arrPositions.push({ session, layout });
  });

  return { arrPositions: arrPositions, maxWidth: maxWidth + trackW };
}

function mapStateToProps(state, ownProps) {
  var sessions = state.scheduleData.payload.session_by_eventid;
  // var sessionUsers = state.scheduleData.payload.appuser_access_by_eventid;
  var sessionUsers =
    state.singleSessionAssociatedUsers &&
    state.singleSessionAssociatedUsers.data
      ? state.singleSessionAssociatedUsers.data
      : [];
  // console.log("sessionUsers :- ", sessionUsers);

  if (sessions) {
    if (DEVELOPMENT_TYPE === "koachify") {
      sessions = state.scheduleData.payload.session_by_eventid.filter(
        (session) =>
          session.starttime >=
            `${state.selectedScheduleDate.scheduledate} 00:00:00` &&
          session.endtime <=
            `${state.selectedScheduleDate.scheduledate} 23:59:59`
      );
    } else {
      sessions = state.scheduleData.payload.session_by_eventid.filter(
        (session) => session.scheduletrackid === ownProps.track.scheduletrackid
      );
    }
  }

  var lastSessionTime = sessions
    .map(function (e) {
      return e.endtime;
    })
    .sort()
    .reverse()[0]; //Fetching end time of current track;
  var lastSession = sessions.filter((obj) => {
    return obj.endtime == lastSessionTime;
  })[0];

  if (!lastSession) {
    lastSession = {
      starttime: `${state.selectedScheduleDate.scheduledate} 00:00:00`,
      endtime: `${state.selectedScheduleDate.scheduledate} 00:00:00`,
    };
  }

  sessions = _.sortBy(sessions, (e) => e["starttime"]);
  // console.log("sessions :- ", sessions);

  let slots = ownProps.timeSlots; // Session times display array (left side time slot)
  // Get the selected date start time unix value
  let sessionSTime = moment().unix();
  if (slots.length > 0) {
    let timeStr = `${state.selectedScheduleDate.scheduledate} ${slots[0]
      .toString()
      .padStart(2, "0")}:00:00`;
    sessionSTime = moment(`${timeStr}`).unix();
  }

  let arrangedSessions = getPositionOfSessions(
    sessions,
    sessionSTime,
    state.sessionScreenZoom
  );
  // console.log("arrangedSessions :- ", arrangedSessions);

  return {
    isFetching: state.scheduleData.isFetching,
    sessions: arrangedSessions.arrPositions,
    mawWidth: arrangedSessions.maxWidth,
    sessionUsers,
    lastSession: lastSession,
    sessionScreenZoom: state.sessionScreenZoom,
  };
}

export default connect(mapStateToProps)(ScheduleTrack);
